import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import content from '../data';

const STORAGE_KEY = 'lang';
const LanguageContext = createContext(null);

function getInitialLang() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && saved in content) return saved;
  } catch {}
  return 'en';
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
  }, [lang]);

  const value = useMemo(() => {
    const numberFormat = new Intl.NumberFormat(lang === 'bn' ? 'bn-BD' : 'en-US', { useGrouping: false });
    return {
      lang,
      toggleLang: () => setLang(lang === 'en' ? 'bn' : 'en'),
      content: content[lang],
      formatNumber: (n) => numberFormat.format(n),
    };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
